import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const VerifyEmail = () => {
  const [message, setMessage] = useState("Verifying...");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      fetch(`${API_BASE}/api/auth/verify-email?token=${token}`)
        .then((res) => {
          if (res.ok) {
            setMessage("Email verified successfully! Redirecting to login...");
            setTimeout(() => navigate("/login"), 3000);
          } else {
            setMessage("Email verification failed. Link may have expired.");
          }
        })
        .catch((err) => {
          console.error("Verification error:", err);
          setMessage("Something went wrong.");
        });
    } else {
      setMessage("No verification token provided.");
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md text-center max-w-md">
        <h1 className="text-2xl font-bold mb-4">Email Verification</h1>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default VerifyEmail;
